import { GoUnmute, GoMute } from 'react-icons/go';
import { HStack } from 'ui_2';
import { useGameStore } from '@src/data/useGameStore';

export const MuteButton = () => {
  const [isMuted, setIsMuted] = useGameStore((state) => [
    state.isMuted,
    state.setIsMuted,
  ]);

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  return (
    <HStack
      className='right-0 w-[35px] cursor-pointer rounded-full bg-[#13252c] p-2 hover:bg-black active:bg-[#08181f]'
      onClick={toggleMute}
    >
      {isMuted ? (
        <GoMute className='text-aqua' />
      ) : (
        <GoUnmute className='text-aqua' />
      )}
    </HStack>
  );
};
